import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal, Card } from "react-bootstrap";
import { useFieldArray, useForm } from "react-hook-form";
import classNames from "classnames";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/masters/cancellation-policy`);
    reset(response?.data);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      console.log(data);
      const response = await postData(`/masters/cancellation-policy`, data);
      console.log(response);
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        // props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const {
    fields: GiftWrapPriceFields,
    append: GiftWrapPriceAddOn,
    remove: removeGiftWrapPrice,
  } = useFieldArray({
    control,
    name: "cancellation_policy",
  });
  const [CancellationPolicyError, setCancellationPolicyError] = useState("");

  useEffect(() => {
    register("cancellation_policy", {
      validate: (value) => {
        const isValid = value && value.length > 0;
        setCancellationPolicyError(
          isValid ? "" : "At least one Cancellation Policy is required"
        );
        return isValid;
      },
    });
  }, [register]);
  const handleKeyPress = (event) => {
    if (event.key === "-" || event.key === "e") {
      event.preventDefault(); // Prevent negative sign and scientific notation
    }
  };
  return (
    <>
      {/* <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Cloth Size
          </Modal.Title>
        </Modal.Header>
        <Modal.Body> */}
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
          <Row className="justify-content-center">
              <div className="main-form-section mt-5"></div>
              <Card.Title>
              Cancellation Policy
                {CancellationPolicyError && (
                  <div className="text-danger">{CancellationPolicyError}</div>
                )}
              </Card.Title>
              <hr />
              

              {GiftWrapPriceFields.map((val, index) => (
                <div key={val.id} className="main-form-section mt-3">
                  <Row>
                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Start hour</Form.Label>
                          <Form.Group>
                            <InputGroup>
                              <Form.Control
                               
                                type="number"
                                name={`cancellation_policy.${index}.start_hour`}
                                placeholder="Start price"
                               
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.cancellation_policy?.[index]
                                      ?.start_hour,
                                })}
                                {...register(
                                  `cancellation_policy.${index}.start_hour`,
                                  {
                                    required: "Start price is required",
                                    
                                    // validate: (value) =>
                                    //   value > 0 ||
                                    //   "Start price must be greater than 0",
                                  }
                                )}
                                onKeyPress={handleKeyPress}
                              />
                            </InputGroup>
                            {errors?.cancellation_policy?.[index]
                              ?.start_hour && (
                              <span className="text-danger">
                                {
                                  errors?.cancellation_policy?.[index]
                                    ?.start_hour.message
                                }
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>End Hour</Form.Label>
                          <Form.Group>
                            <InputGroup>
                              <Form.Control
                               
                                type="number"
                                name={`cancellation_policy.${index}.end_hour`}
                                placeholder="End price"
                                min="0" // Ensure no negative values are allowed
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.cancellation_policy?.[index]
                                      ?.end_hour,
                                })}
                                {...register(
                                  `cancellation_policy.${index}.end_hour`,
                                  {
                                    required: "End price is required",
                                    // validate: (value) =>
                                    //   value > 0 ||
                                    //   "Start price must be greater than 0",
                                  }
                                )}
                                onKeyPress={handleKeyPress}
                              />
                            </InputGroup>
                            {errors?.cancellation_policy?.[index]?.end_hour && (
                              <span className="text-danger">
                                {
                                  errors?.cancellation_policy?.[index]?.end_hour
                                    .message
                                }
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Percentage</Form.Label>
                          <Form.Group>
                            <InputGroup>
                              <Form.Control
                              
                                type="number"
                                name={`cancellation_policy.${index}.percentage`}
                                placeholder="price"
                                min="0" // Ensure no negative values are allowed
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.cancellation_policy?.[index]
                                      ?.price,
                                })}
                                {...register(
                                  `cancellation_policy.${index}.percentage`,
                                  {
                                    required: "End price is required",
                                    // validate: (value) =>
                                    //   value > 0 ||
                                    //   "Start price must be greater than 0",
                                  }
                                )}
                                onKeyPress={handleKeyPress}
                              />
                            </InputGroup>
                            {errors?.cancellation_policy?.[index]
                              ?.percentage && (
                              <span className="text-danger">
                                {
                                  errors?.cancellation_policy?.[index]
                                    ?.percentage.message
                                }
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>

                    <Col lg={3}>
                      <button
                        className="btn btn-danger mt-3"
                        type="button"
                        onClick={() => removeGiftWrapPrice(index)}
                      >
                        Remove Cancellation Policy
                      </button>
                    </Col>
                  </Row>
                </div>
              ))}

              <div className="main-form-section mt-3"></div>
              <hr />
              <div className="text-center">
                <button
                  type="button"
                  className="btn btn-primary mb-3"
                  onClick={() => GiftWrapPriceAddOn({})}
                >
                  + Add Cancellation Policy
                </button>
              </div>
              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        {/* </Modal.Body>
      </Modal> */}

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
